<template>

  <div class="row" style="padding: 20px;">

    <form action="#">
      <div id="information_body" class=" col-xs-12 col-xs-offset-0 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
        <div class="row">
          <div id="infor_label_1" class="col-xs-12" >
            我的信息
          </div>
          <div class="col-xs-12 col-xs-offset-0 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-0" style="padding: 0;">
            <div class="infor_body_row">
              <div class="infor_label_2">账户信息：</div>
              <div class="infor_input">
                <div v-if="isContextEditing == false">{{item.nickName}}</div>
                <input type="text" :value="item.nickName" name="username" placeholder="请输入账户名称" v-else>
              </div>
            </div>
            <div class="infor_body_row">
              <div class="infor_label_2">性别：</div>
              <div class="infor_input">
                <div v-if="isContextEditing == false">{{genderText}}</div>
                <select name="gender">
                  <option value="0" :selected="item.gender == 0">请选择性别</option>
                  <option value="1" :selected="item.gender == 1">男</option>
                  <option value="2" :selected="item.gender == 2">女</option>
                </select>
              </div>
            </div>

            <div class="infor_body_row">
              <div class="infor_label_2">年龄：</div>
              <div class="infor_input">
                <div v-if="isContextEditing == false">{{item.age}}</div>
                <input type="text" :value="item.age" name="age" placeholder="请输入年龄" v-else>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-xs-offset-0 col-sm-10 col-sm-offset-1 col-md-6 col-md-offset-0" style="padding: 0;">
            <div class="infor_body_row">
              <div class="infor_label_2">所在地区：</div>
              <div class="infor_input">
                <div v-if="isContextEditing == false">{{item.address}}</div>
                <input type="text" :value="item.address" name="address" placeholder="请输入所在地区" v-else>
              </div>
            </div>
            <div class="infor_body_row">
              <div class="infor_label_2">个人简介：</div>
              <div class="infor_input">
                <div v-if="isContextEditing == false" >{{item.profile}}</div>
                <input type="text" :value="item.profile" name="profile" placeholder="请填写简介"  v-else>
              </div>
            </div>

          </div>
        </div>
          <div></div>

        <input class="infor_button" type="button" @click="enterEditingState" value="修改信息" v-if="isContextEditing == false">
        <input class="infor_button" type="submit" value="提交修改" v-else>
        <div style="clear: both;"></div>

      </div>
    </form>

  </div>

</template>

<script>
export default {
  name: "PersonalInformation",
  data() {
    return {
      title: '我的信息',
      isContextEditing: true,
      item: {
        nickName: '哈莫雷特',
        gender: 1,
        age: 33,
        address: '上海市杨浦区',
        profile: '这个人很懒，什么都没写'
      }
    }
  },
  computed: {
    genderText() {
      let gender = this.item.gender;
      switch (gender) {
        case 1:
          return '男';
        case 2:
          return '女';
        default:
          return '未知'
      }
    }
  },
  methods: {
    enterEditingState() {

    }
  }

}
</script>

<style scoped>

  #information_outer {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #information_body {
    border: solid 1px #cbb042;
    min-width: 350px;
    padding-bottom: 40px;
    padding-top: 40px;
  }

  #infor_label_1 {
    color: #cbb042;
    font-size: 1.5rem;
    padding-left: 4vw;
  }

  .infor_input div, .infor_input select {
    border-radius: 4px;
    border: solid 1px #cbb042;
    text-align: center;
    font-size: 1rem;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
  }
  .infor_input select {
    padding-left: 15px;
    padding-right: 15px;
  }

  .infor_input input {
    outline: none;
    border-radius: 4px;
    border: solid 1px #cbb042;
    font-size: 1rem;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-indent: 15px;
  }


  .infor_input input::-webkit-input-placeholder {
    color: #666;

  }

  .infor_body_row {
    display: flex;
    flex-wrap: nowrap;
    padding-left: 4vw;
    padding-right: 4vw;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }


  .infor_body_row > div:first-child {
    min-width: 100px;
    max-width: 150px;
    width: 30%;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 1rem;
  }

  .infor_body_row > div:last-child {
    min-width: 170px;
    width: 65%;
    max-width: 350px;
  }

  .infor_button {
    background-color: #cbb042;
    outline: none;
    color: white;
    border: solid 1px transparent;
    height: 30px;
    border-radius: 15px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 30px;
    float: right;
    margin-right: 5vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalInformation.vue